import { useEffect } from 'react';
import { Outlet, useRouterState } from '@tanstack/react-router';
import { Wordmark } from '@leoradating/ui';
import { NoticeBanner, useNotice } from '@/components/NoticeBanner';
import styles from './styles.module.scss';

export const AuthLayout = () => {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const { clearNotice } = useNotice();

  useEffect(() => {
    clearNotice();
  }, [pathname, clearNotice]);

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <Wordmark size={34} as="h1" />
      </header>
      <div className={styles.notice}>
        <NoticeBanner />
      </div>
      <Outlet />
    </div>
  );
};
